import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "56",
  height: "56",
  viewBox: "0 0 56 56",
  fill: "none"
}
const _hoisted_2 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M35 18.6667V37.3333H11.6667V18.6667H35ZM37.3333 14H9.33333C8.05 14 7 15.05 7 16.3333V39.6667C7 40.95 8.05 42 9.33333 42H37.3333C38.6167 42 39.6667 40.95 39.6667 39.6667V31.5L49 40.8333V15.1667L39.6667 24.5V16.3333C39.6667 15.05 38.6167 14 37.3333 14Z",
      fill: $props.color
    }, null, 8, _hoisted_2)
  ]))
}